/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_EmptyInputs */

const en_inbox_empty = /** @type {(inputs: Inbox_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No suggestions`)
};

const de_inbox_empty = /** @type {(inputs: Inbox_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Vorschläge`)
};

/**
* | output |
* | --- |
* | "No suggestions" |
*
* @param {Inbox_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const inbox_empty = /** @type {((inputs?: Inbox_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_inbox_empty(inputs)
	return en_inbox_empty(inputs)
});